import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject } from 'rxjs';

import { Role } from './../models/role.model';
import { RolesService } from '../services/roles.service';
import { delay, map, finalize } from 'rxjs/operators';

export class RolesDataSource implements DataSource<Role> {
  private rolesSubject = new BehaviorSubject<Role[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();
  count: number;
  constructor(private rolesService: RolesService) {}

  connect(collectionViewer: CollectionViewer): Observable<Role[]> {
    return this.rolesSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.rolesSubject.complete();
    this.loadingSubject.complete();
  }

  loadRoles(
    page?: number,
    limit?: number,
    sort?: string,
    viewOnlyActive?: boolean
  ) {
    this.loadingSubject.next(true);
    this.rolesService
      .getRoles(page, limit, sort, viewOnlyActive)
      .pipe(
        map(val => {
          this.count = val.count;
          return val.roles;
        }),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(p => this.rolesSubject.next(p));
  }
}
